$( document ).ready(function() {
  
	//  Get Added users
    var users = $('.liveUsers').val();
    var users_arr = users.split(",");   
    
    var refreshToken = '';
  	var clientID = '';
  	var SecretKey = '';
  	
 	//   Fetch user credentials  
    const getCredentials = () => {
        return new Promise((resolve, reject) => {
        (async => {
            try{
            $.ajax({
                url   : 'https://twitch-app-gcxmi.ondigitalocean.app/getauth',
                type  : 'get',
                headers: {
                "Content-Type":"application/json"
                },
                success:function(result){
                var authData = result.data;
                refreshToken = authData.refreshToken;
                clientID = result.clientID;
                SecretKey = result.SecretKey;
                
                let detailsObj = {
                    refreshToken : refreshToken,
                    clientID : clientID,
                    SecretKey : SecretKey
                }
                
                return resolve({status : 'success',data : detailsObj})

                },error: function(err){
                console.log('my error',err)
                return resolve({status : 'error',error : err})
                }
            })
            }
            catch(err){
                return resolve({status : 'error',error : err})
            }       
        })()
        })
  }
  
  
  //   get access token
  const getAccessToken = () => {
    return new Promise((resolve,reject) => {
      (async() => {
         try{
            var result = await getCredentials();

            const refreshToken = result.data.refreshToken;
            const clientID     = result.data.clientID;
            const SecretKey    = result.data.SecretKey;
            $.ajax({
              url   : `https://id.twitch.tv/oauth2/token?grant_type=refresh_token&refresh_token=${refreshToken}&client_id=${clientID}&client_secret=${SecretKey}`,
              type  : 'POST',
              headers: {
                "Content-Type":"application/json"
              },
              success:function(result){
                const authToken = result.access_token;
                const accessData = {
                  authToken : authToken,
                  clientID : clientID
                }
                return resolve({status : 'success',data : accessData})

              },error: function(err){
                console.log('my error',err)
                return resolve({status : 'error',error : err})
              }
            })
        }   
        catch(err){
          return resolve({status : 'error',error : err})
        }

      })()
    });
  }
    
                    
    var allLiveusers = '';
    var streamingList = [];

    users_arr.forEach((val, index) => {
  		allLiveusers += `&user_login=${val}`;
    });

    (async() => {

    try{
        var result = await getAccessToken();

        const accessToken = await result.data.authToken;
        const clientID = await result.data.clientID;

            $.ajax({
              url: `https://api.twitch.tv/helix/streams?${allLiveusers}`,
                type: 'get',
                headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Client-Id": clientID
                },
                success:function(result){

                if(result.data.length !== 0){
                    $(`.twitch-container`).removeClass("visual-hide"); // this line is added by himanshu                      
                    
                    
                    $.each(result.data, function (key,val) {
                        
                        var userProfile = '';
                        
                        $.ajax({
                        url   : `https://api.twitch.tv/helix/users?login=${val.user_login}`,
                        type  : 'get',
                        headers: {
                            "Authorization": `Bearer ${accessToken}`,
                            "Client-Id": clientID
                        },
                        success:function(response){                              
                            
                            (async () => {
                            userProfile = await response.data[0].profile_image_url;
                            })()
                            
                        },error: function(err){
                            console.log('my error',err)
                        }
                        })
                        
                        var profileImg = '';                     
                        
                        setTimeout(function(){
                        
                        if(userProfile != ''){                              
                            profileImg = userProfile.replace('-300x300','-50x50');;

                        }else{
                            var url  = val.thumbnail_url;
                            var url1 = url.replace('{width}', '50');
                            var profileImg = url1.replace('{height}','50');
                        }
                        
                        let newList = `
                            <div class="twitch_row row-${key}">
                                <a target=_blank href="https://www.twitch.tv/${val.user_login}">
                                <div class="dropdown-flex">
                                    <div class="twitch-block-one">
                                    <img src="${profileImg}">
                                    </div>
                                    <div class="twitch-block-two">
                                    <div class="playername"><h4>${val.user_name}</h4></div>
                                        <div class="game-timing"><h5>Live<span>${val.viewer_count} viewers </span></h5></div>
                                    </div>
                                    <div class="twitch-block-three">
                                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 13L7 7L0.999999 1" stroke="#5D41EA" stroke-width="2"/>
                                    </svg>
                                    </div>
                                </div>
                                </a>
                            </div>`;
                        streamingList.push(newList);
                        
                        },1000)

                    });
                    
                    setTimeout(function(){
                        $(".twitch_wrapper").prepend(streamingList);
                        $(".twitch_wrapper").removeClass("visual-hide");
                        $("#my-loader").addClass("visual-hide");
                    },1000);
                    
                }else{
                    $('body').addClass('no-players');
                    $(`.twitch-drodown`).removeClass("visual-hide");

                    $(".dropdown_nouser").css('display','block')
                    $(".old-twitch-container").css('display','block')
                    $(".twitch-drodown").css('display','none')                      
                    
                    let headerHeight = $('#shopify-section-header').height();
                    $(':root').css('--headerHeight', Math.ceil(headerHeight)+'px');
                }

                },error: function(err){
                  console.log('my error',err.responseJSON.error)                    
                  const authLink = `<li class="auth-token get-twitch text-gander"><p> ${err.responseJSON} </p>`;                    
                  $("#dropdown-list").html(authLink);

                  // added by hardik for when there is no user 
                  $('body').addClass('no-players');
                  $(`.twitch-drodown`).removeClass("visual-hide");
                  $(".dropdown_nouser").css('display','block');
                  $(".old-twitch-container").css('display','block');
                  $(".twitch-drodown").css('display','none');
                  
                  let headerHeight = $('#shopify-section-header').height();
                  $(':root').css('--headerHeight', Math.ceil(headerHeight)+'px');
                }
            })

    }
    catch(err){

    }
       
       
   })();
 
  //   Start twitch code
  // hardik added code
  function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
      ( navigator.maxTouchPoints > 0 ) ||
      ( navigator.msMaxTouchPoints > 0 );
  }

  setInterval( function () {
    var offset = 0;
    var elementHeight = $('.twitch_row').innerHeight() + 4;
    var offsetArray = [];
    var elementArray = [];
    var length = $('.twitch_row:not(.visual-hidden)').length;

    if (length > 0) {
      
      $('.twitch_row:not(.visual-hidden)').each( function (index, element) {
        elementArray.push(element);
      });

      for (i = 0; i < length; i++) {
        offset = elementHeight * i;
        offsetArray.push(offset);
      }

      $(elementArray).each( function (index, element) {
        var elementIndex = index + 1;
        var offsetTop = offsetArray[index];
        $(element).css('top', offsetTop).addClass('twitch-card-'+elementIndex);
      }); 
      
      $('.twitch-drodown').attr('data-length', length);
      $('.twitch_wrapper').css('height', (offset + elementHeight));

      if (length > 1) {
        if( is_touch_enabled() ) {
          $('.twitch-drodown').addClass('show-loadmore');
        } else {
          $('.twitch-drodown').removeClass('show-loadmore');
        }
      } else {
        $('.twitch-drodown').removeClass('show-loadmore');
      }
    }
  }, 1000);

  $('.twitch-drodown').hover( function () {
    if (!$(this).hasClass('show-loadmore')) {
      $(this).addClass('opened');
      $('.twitch_container').scrollTop(0);
    }
  }, function () {
    if (!$(this).hasClass('show-loadmore')) {
      $(this).removeClass('opened');
    }
  });

  $(document).on('click', '.twitch_load_btn', function () {
    $('.twitch-drodown').toggleClass('opened');
    if ($('.twitch-drodown').hasClass('opened')) {
      $('.twitch_container').scrollTop(0);
    }
  });

});